<template>
  <div class="under-48">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="100%"
      height="100%"
      viewBox="0 0 82 93"
    >
      <defs><path id="a" d="M0 92.868h81.988V0H0z" /></defs>
      <g fill="none" fill-rule="evenodd">
        <path
          :fill="color"
          d="M30.396 35.192a4.325 4.325 0 0 0-4.322 4.318 4.325 4.325 0 0 0 4.322 4.318 4.325 4.325 0 0 0 4.322-4.318 4.325 4.325 0 0 0-4.322-4.318m0 9.823a5.514 5.514 0 0 1-5.51-5.505 5.514 5.514 0 0 1 5.51-5.506c3.038 0 5.51 2.47 5.51 5.506a5.514 5.514 0 0 1-5.51 5.505M24.459 47.358a2.529 2.529 0 0 0-2.527 2.525V61.14c0 1.182.838 2.22 1.993 2.467l.507.11-.04.516c-.004.064-.01.128-.01.193v13.767a2.53 2.53 0 0 0 2.528 2.525h6.973a2.53 2.53 0 0 0 2.527-2.525V64.427c0-.062-.005-.125-.01-.187l-.04-.517.507-.115a2.536 2.536 0 0 0 1.993-2.467V49.883a2.529 2.529 0 0 0-2.527-2.525H24.459zm9.424 34.549H26.91a3.718 3.718 0 0 1-3.716-3.713V64.631a3.734 3.734 0 0 1-2.45-3.49V49.883a3.718 3.718 0 0 1 3.715-3.712h11.874a3.718 3.718 0 0 1 3.716 3.712V61.14a3.734 3.734 0 0 1-2.45 3.49v13.563a3.718 3.718 0 0 1-3.716 3.713zM51.592 35.192a4.325 4.325 0 0 0-4.323 4.318 4.325 4.325 0 0 0 4.323 4.318 4.325 4.325 0 0 0 4.322-4.318 4.325 4.325 0 0 0-4.322-4.318m0 9.823a5.514 5.514 0 0 1-5.511-5.505 5.514 5.514 0 0 1 5.51-5.506c3.039 0 5.511 2.47 5.511 5.506a5.514 5.514 0 0 1-5.51 5.505M45.655 47.358a2.529 2.529 0 0 0-2.528 2.525V61.14c0 1.181.838 2.22 1.993 2.467l.507.11-.039.516c-.005.064-.01.128-.01.193v13.767a2.53 2.53 0 0 0 2.527 2.525h6.973a2.53 2.53 0 0 0 2.527-2.525V64.427c0-.065-.005-.129-.01-.193l-.04-.517.508-.109a2.536 2.536 0 0 0 1.993-2.467V49.883a2.529 2.529 0 0 0-2.527-2.525H45.655zm9.423 34.549h-6.973a3.718 3.718 0 0 1-3.715-3.713V64.631a3.734 3.734 0 0 1-2.451-3.49V49.883a3.718 3.718 0 0 1 3.716-3.712h11.874a3.718 3.718 0 0 1 3.715 3.712V61.14a3.734 3.734 0 0 1-2.45 3.49v13.563a3.718 3.718 0 0 1-3.716 3.713z"
        />
        <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
        <path
          :fill="color"
          d="M1.188 80.72H80.8V1.186H1.19v79.532zM0 81.905h81.988V0H0v81.906z"
          mask="url(#b)"
        />
        <path
          :fill="color"
          d="M14.53 81.313h-1.188V23.401c0-4.576 3.727-8.3 8.308-8.3h38.687c4.582 0 8.309 3.724 8.309 8.3v57.765h-1.189V23.4c0-3.922-3.194-7.113-7.12-7.113H21.65c-3.926 0-7.12 3.191-7.12 7.113v57.912zM20.01 89.318h41.967v-1.187H20.011z"
          mask="url(#b)"
        />
        <path
          :fill="color"
          d="M21.224 92.868l-7.183-4.143 7.183-4.143zM60.763 92.868l7.184-4.143-7.184-4.143z"
          mask="url(#b)"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'Under48',
  props: {
    color: VueTypes.string.isRequired,
  },
};
</script>

<style lang="scss" scoped>
.under-48 {
  width: 82px;
  height: 93px;
}

@media (max-width: $mobile-max-width) {
  .under-48 {
    width: 61px;
    height: 69px;
  }
}
</style>
